import { NOTIFICATIONTYPE } from "Store/Notification/ActionTypes";
import { ACTION_TYPE, getActionTypes } from "Store/Shared/Actions/Helpers";
import ACTIONS from "./ActionTypes";
import { ModuleId } from "./PropTypes";

export const fetchModules = (): ACTION_TYPE => ({
    types: getActionTypes(ACTIONS.FETCH_MODULES),
    shouldCallAPI: state => state.settings.modules._forceFetch,
    callAPI: {
        url: '/api/settings/modules'
    }
});

export const patchModule = (id: ModuleId, body: any): ACTION_TYPE => ({
    types: getActionTypes(ACTIONS.PATCH_MODULE),
    callAPI: {
        method: 'PATCH',
        url: `/api/settings/modules/${id}`,
        body: body
    },
    notification: {
        [NOTIFICATIONTYPE.SUCCESS]: 'Succesvol aangepast',
        [NOTIFICATIONTYPE.ERROR]: 'Aanpassing mislukt'
    }
});

export const createModule = (body: any): ACTION_TYPE => ({
    types: getActionTypes(ACTIONS.CREATE_MODULE),
    callAPI: {
        method: 'POST',
        url: `/api/settings/modules`,
        body: body
    },
    notification: {
        [NOTIFICATIONTYPE.SUCCESS]: 'Succesvol aangepast',
        [NOTIFICATIONTYPE.ERROR]: 'Aanpassing mislukt'
    }
})